import type { AiMockSide } from '@/mocks/db/schema';
import { getSequenceSidebarData } from '@/routes/_individual/individual/portal/-api/sequence';
export async function loadChatLandingData(side: AiMockSide = 'individual') {
  return getSequenceSidebarData(side);
}